import { InfoPanelForOfficialDocumentation } from "../../../components/info-panel";
import { Platform } from "../constants";

import { SetupSection } from "./components/setup-section";
import { Code, OrderedList, SubSubSectionHeader } from "./components/styled";
import { URLVerification } from "./components/utms";
import { type PlatformDetails } from "./platform-details";
import { UtmSpendAdditionalDetails } from "./utm-spend-details";

const PLATFORM = Platform.POSTSCRIPT;

const POSTSCRIPT_GUIDE_URL =
  "https://help.postscript.io/hc/en-us/articles/4403539152539-New-Feature-Adjust-Global-UTM-Parameters#About-Global-UTM-Parameters";

export const PostscriptDetails: PlatformDetails = {
  northbeamDocUrl: "",
  officialDocUrl: POSTSCRIPT_GUIDE_URL,
  additionalDetails: UtmSpendAdditionalDetails(PLATFORM),
};

export const PostscriptSetup = () => (
  <>
    <SetupSection title="Set up global UTMs for Postscript">
      <div className="flex flex-col gap-4">
        <span>
          <b>Note:</b>You will only need to setup your global UTMs once for
          Postcript
        </span>
        <div className="flex flex-col gap-2">
          <SubSubSectionHeader>
            Make sure you’ve followed these steps:
          </SubSubSectionHeader>
          <OrderedList
            variant="upper-alpha"
            className="m-0 text-sm leading-tight"
          >
            <>
              Open <a href="POSTSCRIPT_GUIDE_URL">Postscript’s UTM Guide</a>
            </>
            <>
              Navigate to the ‘Campaign UTM Parameters’ following the guide in
              step 1a
            </>
            <>
              <span className="mr-2">
                Leave the ’Source’ field as ’Static Value’ with the value set to
              </span>
              <Code>postscript</Code>
            </>
            <>
              Set the Campaign field to Dynamic Value and choose Campaign Name
              from the dropdown.
            </>
            <>
              Finally, add a custom parameter with the following structure
              <div className="mt-2 ml-[28px]">
                <div className="flex gap-2">
                  <span>1ea.</span>
                  <span>Key:</span>
                  <Code>utm_medium</Code>
                </div>
                <div className="flex gap-2">
                  <span>1eb.</span>
                  <span>Value:</span>
                  <Code>sms</Code>
                </div>
              </div>
            </>
          </OrderedList>
        </div>
        <InfoPanelForOfficialDocumentation
          platform={PLATFORM}
          docUrl={POSTSCRIPT_GUIDE_URL}
        />
      </div>
    </SetupSection>
    <URLVerification platform={PLATFORM} />
  </>
);
